import React, { useState, useEffect } from 'react';
import { FaTimes, FaPlus } from 'react-icons/fa';
import onClickOutside from 'react-onclickoutside';
import api from '../../../services/api';
import * as Style from './style';
import color from '../../../config/colors.json';
import Card from '../Card';
import './style.scss';

const SearchInput = ({
	campaignRange, addRange, removeByCondition, gtm,
}) => {
    const [query, setQuery] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [addedRegion, setAddedRegion] = useState({});
    const [isValid, setIsValid] = useState(true);

    useEffect(() => {
        if (query !== '') {
            api.get(`/api/v2/cities?query=${encodeURI(query)}`)
                .then(response => setSuggestions(response.data.data));
        }
    }, [query]);

    const removeRegion = id => removeByCondition(item => item.id !== id);

    useEffect(() => {
        setIsValid(Object.entries(addedRegion).length > 0);
    }, [addedRegion]);

    let timer;
    const inputQuery = (val) => {
        clearTimeout(timer);
        setInputValue(val);
    };

    useEffect(() => {
        if (inputValue !== '') {
            timer = setTimeout(() => {
                setQuery(inputValue);
            }, 700);
        } else {
            setSuggestions([]);
            setQuery('');
        }
    }, [inputValue]);

    const focusQuery = () => {
        if (query !== '') {
            api.get(`/api/v2/cities?query=${encodeURI(query)}`)
                .then(response => setSuggestions(response.data.data));
        }
    };

    const getSuggestion = (val) => {
        setAddedRegion(val);
        setInputValue(`${val.city} - ${val.province}`);
        setSuggestions([]);
    };

    const handleRange = (city) => {
        if (isValid) {
			gtm.sendGtmMetrics('location');
			addRange(city);
			setInputValue('');
            return setAddedRegion({});
        }

        return false;
    };

    SearchInput.onClickOutside = () => setSuggestions([]);

    return (
	<div className="row">
		<div className="col-12">
			<div className="row">
				<div className="col-10">
					<div className="d-flex flex-column">
						<Style.InputContainer>
							{
                            suggestions.length !== 0 && (
                            <Style.Prediction className="region-prediction-list">
	{
                                    suggestions.map(data => (
	<li key={data.id} data-city-id={data.id}>
		<button
			type="button"
			onClick={() => getSuggestion(data)}
		>
			{data.city} - {data.province}
		</button>
	</li>
                                    ))
                                }
                            </Style.Prediction>
                            )
                            }
							<div className="d-flex flex-row">
								<Style.Question>
									Seleciona seu público alvo:
								</Style.Question>
							</div>
							<div className="d-flex flex-row">
								<Style.Input
									type="text"
									name="location"
									placeholder="Adicionar cidade ou estado"
									onFocus={focusQuery}
									onChange={e => inputQuery(e.target.value)}
									value={inputValue}
								/>
								<Style.Icon>
									<FaPlus
										type="button"
										id="add-city"
										fontsize="14px"
										padding="11px"
										backgroundcolor={color.lightBlue}
										onClick={() => handleRange(addedRegion)}
									/>
								</Style.Icon>
							</div>
						</Style.InputContainer>
					</div>
				</div>
			</div>
			<Style.LocationList>
				{
                    campaignRange.map(region => (
	<div>
		<Card
			noshadow
			bgColor={color.greyMidias}
			borderRadius="25px"
			padding="8px 15px"
			width="auto"
			className="selected-cities"
		>
			<Style.LocationItem>
				<Style.LocationCardText>{region.city}</Style.LocationCardText>
				<Style.CloseButton onClick={() => removeRegion(region.id)}>
					<FaTimes />
				</Style.CloseButton>
			</Style.LocationItem>
		</Card>
	</div>
                    ))
                }
			</Style.LocationList>
		</div>
	</div>
    );
};

const clickOutsideSuggestion = {
    handleClickOutside: () => SearchInput.onClickOutside,
};

export default onClickOutside(SearchInput, clickOutsideSuggestion);
